<template>
  <div>
    <!-- UX: Título, botão para guiar usuário e texto -->
    <titulo-lancamento-historico @cadastrar="openModal" />

    <div class="row">
      <div class="col-12 col-md-4">
        <input-text
          ref="documento"
          v-model="filtro.documento"
          type="text"
          label="FINANCEIRO_CONTAS_PAGAR.DOCUMENTO"
          placeholder="FINANCEIRO_CONTAS_PAGAR.DOCUMENTO_PLACEHOLDER"
        />
      </div>
      <div class="col-12 col-md-4">
        <input-select-search
          v-model="filtro.selecionado"
          label="FINANCEIRO.TIPO_HISTORICO"
          :options="filtro.opcoes.tipoHistorico"
        />
      </div>
      <div>
        <b-button
          variant="primary"
          class="botao-acao-filtro mb-3 w-100"
          @click="atualizarTabela"
        >
          {{ $t('GERAL.FILTRAR') }}
        </b-button>
      </div>
    </div>

    <tabela-historico
      :items="items"
      @atualizar-tabela="atualizarTabela"
      @editar-historico="editarHistoricoLancamento"
      @alterar-ordenacao="novaOrdenacao"
    />

    <modal-historico
      :exibir="modais.historico"
      :form="modais.historicoDados"
      @atualizar-tabela="atualizarTabela"
      @fechar="closeModal"
    />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="atualizarTabela"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';

// Services:
import HistoricoLancamentoService from '@/common/services/historico-lancamento/historico-lancamento.service.js';
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';
// Components:
import TabelaHistorico from './components/Tabela';
import ModalHistorico from './components/Modal';
import Paginacao from '@/components/paginacao/Paginacao';
import TituloLancamentoHistorico from '@/views/financeiro/lancamentos/historico/components/TituloLancamentoHistorico';

import { InputSelectSearch, InputText } from '@/components/inputs';

export default {
  components: {
    TituloLancamentoHistorico,
    TabelaHistorico,
    ModalHistorico,
    Paginacao,
    InputSelectSearch, InputText 
  },
  data() {
    return {
      items: [],
      filtro: {
        selecionado: null,
        documento: null,
        opcoes: {
          tipoHistorico: [],
        },
      },
      filtroUtilizado: '',
      modais: {
        historico: false,
        historicoDados: {
          previsto: true,
        },
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.getTipoHistorico();
    this.atualizarTabela();
  },
  methods: {
    getTipoHistorico() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('historico-financeiro')
        .then(({ data }) => {
          data = data.map((row) => ({
            ...row,
            value: row.id,
            text: row.descricao,
          }));
          this.filtro.opcoes.tipoHistorico = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    editarHistoricoLancamento(item) {
      this.openModal('historico');
      this.buscaDadosHistorico(item.id);
    },
    buscaDadosHistorico(id) {
      this.$store.dispatch(START_LOADING);
      HistoricoLancamentoService.obtemHistoricoLancamentoPorId(id)
        .then(({ data }) => {
          this.modais.historicoDados = data;
          this.modais.historicoDados.tipoHistorico = data.tipoHistoricoCodigo;
          this.modais.historicoDados.tipoFluxoFinanceiro =
            data.tipoFluxoFinanceiroCodigo;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    atualizarTabela() {
      this.$store.dispatch(START_LOADING);
      HistoricoLancamentoService.obterEnumPaginadoPor(
        this.filtro,
        this.paginacao,
        this.campoOrdenado,
        this.ordem
      )
        .then(({ data }) => {
          this.items = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL:
    openModal(key, item) {
      this.modais[key] = true;
      item
        ? (this.modais[`${key}Dados`] = JSON.parse(JSON.stringify(item)))
        : (this.modais[`${key}Dados`] = {});
    },
    closeModal(key) {
      return (this.modais[key] = false);
    },
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.atualizarTabela();
    },
  },
};
</script>
